import { Icon, Typography } from "@kyan/ui";

import { usePortfolioValidations } from "#/hooks/usePortfolioValidations";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";
import { formatInstrumentName } from "#/utils/instrument.utils";

interface InstrumentProps {
  instrument: string;
}

export const Instrument: React.FC<InstrumentProps> = ({ instrument }) => {
  const { market } = usePositionsDrawerMarket();
  const { isLiquidated } = usePortfolioValidations(market);

  return (
    <div className="flex items-center gap-2">
      {isLiquidated && (
        <Icon
          name="attention"
          className="text-error bg-error/15 grid size-4 place-items-center rounded-xs text-[8px]"
        />
      )}
      <Typography primary>{formatInstrumentName(instrument)}</Typography>
    </div>
  );
};
